import {
	type EmailSettings,
	type SaveEmailSettingsRequest,
	apiAppBusinessEmailsettingsGetemailsettings,
	apiAppBusinessEmailsettingsPostemailsettings
} from '#lib/types/generated/index.js';
import { optimisticSet } from '#lib/stores/optimistic.js';
import { writable } from 'svelte/store';

export const emailSettingsStore = writable<EmailSettings>();

export const isEmailSurveyEnabled = (emailSettings: EmailSettings | null | undefined): boolean => {
	return Boolean(
		emailSettings?.surveyEmailCondition && emailSettings.surveyEmailCondition !== 'never'
	);
};

export function toSaveEmailSettingsRequest(form: EmailSettings): SaveEmailSettingsRequest {
	return {
		showLogo: form.showLogo,
		surveyEmailCondition: form.surveyEmailCondition,
		sendBookingReminder: form.sendBookingReminder,
		minutesBeforeBookingReminder: form.minutesBeforeBookingReminder,
		customContent: form.customContent,
		headerText: form.headerText,
		footerText: form.footerText,
		banner: form.banner,
		logo: form.logo
	};
}

export function loadEmailSettings(): void {
	apiAppBusinessEmailsettingsGetemailsettings().then((settings) => {
		emailSettingsStore.set(settings);
	});
}

export function saveEmailSettings(form: EmailSettings): Promise<EmailSettings> {
	return optimisticSet(emailSettingsStore, form, () =>
		apiAppBusinessEmailsettingsPostemailsettings(toSaveEmailSettingsRequest(form))
	);
}
